import { Typography } from "@mui/material";
import { ActionButton } from "components/primitives/ActionBarButton";
import { useCountdown } from "hooks/timers/useCountdown";
import { useTranslation } from "react-i18next";

type BackToHomeButtonProps = {
	finishOrder: () => void;
	seconds?: number;
	labelKey?: "order.step5.backToHome" | "order.refillSummary.confirm";
};

/**
 * Timer button, that redirects user from Order step 5 to Order step 1 after
 * purchase is completed; the refill summary reuses it with its own label and a longer window
 * @param finishOrder
 * @param seconds
 * @param labelKey
 * @constructor
 */
export const BackToHomeButton = ({
	finishOrder,
	seconds = 10,
	labelKey = "order.step5.backToHome",
}: BackToHomeButtonProps) => {
	const { countdown } = useCountdown(seconds, finishOrder);
	const { t } = useTranslation();
	if (countdown > 0) {
		return (
			// `data-seconds` carries the number for tests: the shared i18n mock returns the raw key.
			<ActionButton
				onClick={() => finishOrder()}
				stretch={true}
				data-testid="back-to-home-button"
				data-seconds={String(countdown)}
			>
				<Typography variant="h5" color="white" fontWeight={900} textTransform="uppercase">
					{t(labelKey, { countdown: countdown })}
				</Typography>
			</ActionButton>
		);
	}
	return null;
};
